import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import roleApi from '../api/roleApi';

const RolesMultiSelect = ({ label, value, onChange, error, required }) => {
  const [rolesOptions, setRolesOptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [fetchError, setFetchError] = useState(null);

  useEffect(() => {
    const fetchAllRoles = async () => {
      setLoading(true);
      setFetchError(null);
      try {
        const response = await roleApi.getRoles({ paginate: false });
        const options = response.data.map(role => ({
          value: role.id.toString(),
          label: role.name,
        }));
        setRolesOptions(options);
      } catch (err) {
        console.error('Failed to fetch roles for multi-select:', err);
        setFetchError('Failed to load roles.');
      } finally {
        setLoading(false);
      }
    };
    fetchAllRoles();
  }, []);

  const selectedValues = rolesOptions.filter(option => value.includes(option.value));

  return (
    <div className="mb-4">
      <label htmlFor="roles-multi-select" className="block text-text-gray text-sm font-bold mb-2">
        {label} {required && <span className="text-red-500">*</span>}
      </label>
      <Select
        id="roles-multi-select"
        name="roles"
        options={rolesOptions}
        value={selectedValues}
        onChange={onChange}
        isMulti
        isLoading={loading}
        isDisabled={loading}
        placeholder={loading ? 'Loading roles...' : 'Select Roles'}
        className="react-select-container"
        classNamePrefix="react-select"
        styles={{
          control: (baseStyles, state) => ({
            ...baseStyles,
            backgroundColor: '#374151',
            borderColor: error ? '#EF4444' : '#4B5563',
            '&:hover': {
              borderColor: error ? '#EF4444' : '#6B7280',
            },
            boxShadow: state.isFocused ? '0 0 0 1px #60A5FA' : 'none',
          }),
          multiValue: (baseStyles) => ({
            ...baseStyles,
            backgroundColor: '#4B5563',
          }),
          multiValueLabel: (baseStyles) => ({
            ...baseStyles,
            color: '#F9FAFB',
          }),
          multiValueRemove: (baseStyles) => ({
            ...baseStyles,
            color: '#D1D5DB',
            '&:hover': {
              backgroundColor: '#EF4444',
              color: '#F9FAFB',
            },
          }),
          option: (baseStyles, state) => ({
            ...baseStyles,
            backgroundColor: state.isSelected ? '#3B82F6' : (state.isFocused ? '#4B5563' : '#374151'),
            color: '#F9FAFB',
            '&:active': {
              backgroundColor: '#2563EB',
            },
          }),
          menu: (baseStyles) => ({
            ...baseStyles,
            backgroundColor: '#374151',
          }),
          singleValue: (baseStyles) => ({
            ...baseStyles,
            color: '#F9FAFB',
          }),
          input: (baseStyles) => ({
            ...baseStyles,
            color: '#F9FAFB',
          }),
        }}
      />
      {fetchError && <p className="text-red-500 text-xs italic mt-1">{fetchError}</p>}
      {error && <p className="text-red-500 text-xs italic mt-1">{error}</p>}
    </div>
  );
};

export default RolesMultiSelect;